import React, { useState } from 'react';
import { MethodEnum } from 'axios/type';
import useAxios from 'axios/useAxios';
import ReactSelect from 'components/ReactSelect';
import Button from 'tradevan-ui/Button';
import {
  EnumDownloadType,
  EnumRetailerSetup,
  EnumMasterSort,
} from 'view/Layout/enum';
import { EnumDetail, EnumMaster } from '../../../../init';
import { EnumFlatFileType } from './enum';
import { DownloadProps } from './type';
import { getOrderQueryDownloadOption } from './consts';

const DownloadPdf = (props: DownloadProps) => {
  const {
    pdfPreview,
    userInfoReducer,
    formReturnDetail,
    handleSearch,
    retailerSetup,
    pdfDownload,
  } = props;
  const axios = useAxios();

  const { watch, control, handleSubmit } = formReturnDetail;

  const master = watch('master');
  const detail = watch('detail');
  const pageObj = watch('pageObj');
  const masterSort = watch('masterSort');
  const options = getOrderQueryDownloadOption(
    retailerSetup[EnumRetailerSetup.exportItemList],
  );
  const optionMaxLength = options.reduce((a, b) => {
    return a.label.length > b.label.length ? a : b;
  });
  /** 下載檔案的種類 */
  const [downloadType, setDownloadType] = useState(options[0].value || '');

  // #region 檔案下載相關Function

  // /** 下載PDF */
  // const download = async () => {
  //   const response = await axios.blobAxios<IorderDownloadPreviewRequest>(
  //     MethodEnum.post,
  //     'order/download',
  //     {
  //       [EnumMaster.retailerId]: master[EnumMaster.retailerId],
  //       userRole: userInfoReducer.role,
  //       orderSeqNos: detail
  //         .filter((v) => v.selected && !v.selectHidden) // 有勾選且有看的見
  //         .map((v) => v[EnumDetail.orderSeqNo]),
  //       sort: masterSort
  //         .filter((v) => v[EnumMasterSort.property] !== '')
  //         .map((v) => ({
  //           ...v,
  //           [EnumMasterSort.desc]: v.desc ? 'Y' : 'N',
  //         })),
  //     },
  //   );
  //   axios.blobDownload(response);
  //   handleSubmit(handleSearch())();
  // };

  /** 下載TXT */
  const downloadTxt = async (flatFileType: EnumFlatFileType) => {
    const response = await axios.blobAxios(
      MethodEnum.post,
      'order/exportFlatFile',
      {
        flatFileType,
        retailerId: master[EnumMaster.retailerId],
        userRole: userInfoReducer.role,
        orderSeqNos: detail
          .filter((v) => v.selected && !v.selectHidden) // 有勾選且有看的見
          .map((v) => v[EnumDetail.orderSeqNo]),
        sort: masterSort
          .filter((v) => v[EnumMasterSort.property] !== '')
          .map((v) => ({
            ...v,
            [EnumMasterSort.desc]: v.desc ? 'Y' : 'N',
          })),
      },
    );
    axios.blobDownload(response);
    handleSubmit(handleSearch(pageObj.pageNo, pageObj.pageSize))();
  };

  /** 下載檔案判斷 */
  const handleReportDownload = () => {
    switch (downloadType) {
      case EnumDownloadType.報表下載:
        pdfDownload();
        break;
      case EnumDownloadType.批次預覽:
        pdfPreview();
        break;
      case EnumDownloadType.文字檔下載:
        downloadTxt(EnumFlatFileType.文字檔下載);
        break;
      case EnumDownloadType.貨號文字檔下載:
        downloadTxt(EnumFlatFileType.貨號文字檔下載);
        break;

      default:
        break;
    }
  };
  // #endregion

  return (
    <div className="btn-item float-right">
      <div
        className="form-group d-inline-block"
        style={{
          fontSize: '1rem',
          minWidth: `${optionMaxLength.label.length + 1.5}rem`,
        }}
      >
        <ReactSelect
          styles={{
            option: (obj) => ({
              ...obj,
            }),
          }}
          control={control}
          name=""
          value={downloadType}
          isDisabled={!detail.filter((v) => v.selected).length}
          watchValue={() => {}}
          onChange={(e) => {
            setDownloadType(e as EnumDownloadType);
          }}
          options={options}
        />
      </div>
      <Button
        rounded
        style={{ marginLeft: '0.25rem' }}
        disabled={!detail.filter((v) => v.selected).length}
        onClick={handleReportDownload}
      >
        確定
      </Button>
    </div>
  );
};

export default DownloadPdf;
